import React, { FC } from 'react';
import { Button, Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';
import { FetchSynonymsOptions, Synonym } from '@packages/models/api/synonyms-search-term';
import { Modal } from 'react-bootstrap';
import { StyleSheet } from 'react-native';
import { synonymsService } from '@web/services/singletons';
import { useSynonymsDispatch, deleteSynonym, useSynonymsState } from '@packages/contexts/synonyms';
import { useTranslation } from 'react-i18next';

interface AddSynonymModalProps {
    handleSortChange: (options: FetchSynonymsOptions) => void;
    onHide: () => void;
    selectedSynonym?: Synonym;
    show: boolean;
    showToastMessage: (message: string, type: 'success' | 'error') => void;
}

const useStyles = createUseStyles({
    modal: {
        maxWidth: '528px',
    },
});

const styles = StyleSheet.create({
    title: {
        fontSize: 21,
        fontWeight: 600,
    },
    message: {
        fontSize: 15,
        fontWeight: 400,
    },
    cancelButton: {
        marginRight: 8,
    },
});

export const DeleteSynonymModal: FC<AddSynonymModalProps> = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { show, onHide, selectedSynonym, showToastMessage, handleSortChange } = props;
    const synonymDispatch = useSynonymsDispatch();
    const { error } = useSynonymsState();

    async function handleDeleteSynonym() {
        try {
            if (selectedSynonym?.searchTermId) {
                await deleteSynonym(synonymDispatch, synonymsService, selectedSynonym);
                onHide();
            }
            if (error) {
                showToastMessage(t('Error deleting synonym'), 'error');
            }
            handleSortChange({ sort: 'updatedAt', direction: 'desc' });
        } catch (error) {
            showToastMessage(t('Error deleting synonym'), 'error');
        }
    }

    return (
        <Modal show={show} centered={true} onHide={onHide} size="lg" contentClassName={classes.modal}>
            <Modal.Header>
                <Modal.Title style={styles.title}>{t('Delete Confirmation Synonym')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Typography variant="caption" color="black" style={styles.message}>
                    Do you want to eliminate the search term “{selectedSynonym?.searchTerm}” and their synonyms?
                </Typography>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="ghost-blue" style={styles.cancelButton} onPress={onHide}>
                    {t('Cancel')}
                </Button>
                <Button variant="danger" isLoading={false} disabled={false} onPress={handleDeleteSynonym}>
                    {t('Delete')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
